// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/timeline.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/timeline.proto.
 */
export const file_pull_requests_v1_timeline: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_wrappers]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/timeline
 *
 * Defined by PullRequests::PageData::SharedController#timeline.
 *
 * The legacy endpoint renders a top-level JSON array of timeline items.
 * Proto3-JSON always serializes a message to an object, so the array is
 * wrapped in a repeated `items` field; the client reads `response.items`.
 *
 * @generated from message github.pull_requests.v1.TimelineResponse
 */
export type TimelineResponse = Message<"github.pull_requests.v1.TimelineResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.TimelineItem items = 1;
   */
  items: TimelineItem[];
};

/**
 * Describes the message github.pull_requests.v1.TimelineResponse.
 * Use `create(TimelineResponseSchema)` to create a new message.
 */
export const TimelineResponseSchema: GenMessage<TimelineResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 0);

/**
 * A single timeline entry. `additional_info` is a `oneof` keyed on the item's
 * `type` (see AdditionalInfo); the populated arm matches the item type, and
 * proto3 omits the message entirely when there is no metadata.
 *
 * @generated from message github.pull_requests.v1.TimelineItem
 */
export type TimelineItem = Message<"github.pull_requests.v1.TimelineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The kind of timeline entry. Serializes as the UPPER_SNAKE_CASE enum value
   * name (e.g. TIMELINE_ITEM_TYPE_ISSUE_COMMENT); the client maps it back to
   * its own representation. Unknown/future types serialize as
   * TIMELINE_ITEM_TYPE_UNSPECIFIED.
   *
   * @generated from field: github.pull_requests.v1.TimelineItemType type = 2;
   */
  type: TimelineItemType;

  /**
   * ISO8601 timestamp. Wrapper type because the serializer can emit null.
   *
   * @generated from field: google.protobuf.StringValue timestamp = 3;
   */
  timestamp?: string;

  /**
   * Null/absent for some item types (e.g. PullRequestRevisionMarker). A
   * message field cannot carry an explicit JSON null, so absent is read as
   * null by the client.
   *
   * @generated from field: github.pull_requests.v1.TimelineUser user = 4;
   */
  user?: TimelineUser;

  /**
   * Per-type metadata. Absent (read as null by the client) when the item has
   * no additional info, e.g. CrossReference, PullRequestReviewThread,
   * IssueEdit.
   *
   * @generated from field: github.pull_requests.v1.AdditionalInfo additional_info = 5;
   */
  additionalInfo?: AdditionalInfo;
};

/**
 * Describes the message github.pull_requests.v1.TimelineItem.
 * Use `create(TimelineItemSchema)` to create a new message.
 */
export const TimelineItemSchema: GenMessage<TimelineItem> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 1);

/**
 * @generated from message github.pull_requests.v1.TimelineUser
 */
export type TimelineUser = Message<"github.pull_requests.v1.TimelineUser"> & {
  /**
   * User id. int64 (serialized as a JSON string) since user ids can exceed
   * the int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.pull_requests.v1.TimelineUser.
 * Use `create(TimelineUserSchema)` to create a new message.
 */
export const TimelineUserSchema: GenMessage<TimelineUser> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 2);

/**
 * @generated from message github.pull_requests.v1.Label
 */
export type Label = Message<"github.pull_requests.v1.Label"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message github.pull_requests.v1.Label.
 * Use `create(LabelSchema)` to create a new message.
 */
export const LabelSchema: GenMessage<Label> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 3);

/**
 * Per-type metadata, modeled as a `oneof` keyed on the item's `type`. Each
 * arm is its own message so the JSON nests under the member name, e.g.
 * `{ "additionalInfo": { "issueComment": { "commentId": "1" } } }`. The client
 * narrows on whichever member is present. Wrapper types are used within each
 * arm where a value can be absent vs. present, or where a zero/false value is
 * meaningful and must not be omitted as a proto3 default.
 *
 * @generated from message github.pull_requests.v1.AdditionalInfo
 */
export type AdditionalInfo = Message<"github.pull_requests.v1.AdditionalInfo"> & {
  /**
   * @generated from oneof github.pull_requests.v1.AdditionalInfo.info
   */
  info: {
    /**
     * @generated from field: github.pull_requests.v1.IssueCommentInfo issue_comment = 1;
     */
    value: IssueCommentInfo;
    case: "issueComment";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.IssueEventInfo issue_event = 2;
     */
    value: IssueEventInfo;
    case: "issueEvent";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestReviewInfo pull_request_review = 3;
     */
    value: PullRequestReviewInfo;
    case: "pullRequestReview";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestCommitInfo pull_request_commit = 4;
     */
    value: PullRequestCommitInfo;
    case: "pullRequestCommit";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestRevisionMarkerInfo pull_request_revision_marker = 5;
     */
    value: PullRequestRevisionMarkerInfo;
    case: "pullRequestRevisionMarker";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message github.pull_requests.v1.AdditionalInfo.
 * Use `create(AdditionalInfoSchema)` to create a new message.
 */
export const AdditionalInfoSchema: GenMessage<AdditionalInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 4);

/**
 * @generated from message github.pull_requests.v1.IssueCommentInfo
 */
export type IssueCommentInfo = Message<"github.pull_requests.v1.IssueCommentInfo"> & {
  /**
   * @generated from field: int64 comment_id = 1;
   */
  commentId: bigint;
};

/**
 * Describes the message github.pull_requests.v1.IssueCommentInfo.
 * Use `create(IssueCommentInfoSchema)` to create a new message.
 */
export const IssueCommentInfoSchema: GenMessage<IssueCommentInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 5);

/**
 * @generated from message github.pull_requests.v1.IssueEventInfo
 */
export type IssueEventInfo = Message<"github.pull_requests.v1.IssueEventInfo"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * @generated from field: github.pull_requests.v1.Label label = 2;
   */
  label?: Label;

  /**
   * @generated from field: google.protobuf.StringValue reviewer_login = 3;
   */
  reviewerLogin?: string;

  /**
   * @generated from field: google.protobuf.StringValue reviewer_team_slug = 4;
   */
  reviewerTeamSlug?: string;

  /**
   * @generated from field: google.protobuf.StringValue assignee_login = 5;
   */
  assigneeLogin?: string;

  /**
   * @generated from field: google.protobuf.StringValue previous_title = 6;
   */
  previousTitle?: string;

  /**
   * @generated from field: google.protobuf.StringValue new_title = 7;
   */
  newTitle?: string;

  /**
   * @generated from field: google.protobuf.StringValue before_commit_oid = 8;
   */
  beforeCommitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue after_commit_oid = 9;
   */
  afterCommitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue ref = 10;
   */
  ref?: string;

  /**
   * @generated from field: google.protobuf.StringValue dismissal_message = 11;
   */
  dismissalMessage?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_oid = 12;
   */
  commitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue state_reason = 13;
   */
  stateReason?: string;

  /**
   * @generated from field: google.protobuf.StringValue lock_reason = 14;
   */
  lockReason?: string;

  /**
   * @generated from field: google.protobuf.StringValue review_effort_level = 15;
   */
  reviewEffortLevel?: string;

  /**
   * @generated from field: google.protobuf.StringValue session_url = 16;
   */
  sessionUrl?: string;
};

/**
 * Describes the message github.pull_requests.v1.IssueEventInfo.
 * Use `create(IssueEventInfoSchema)` to create a new message.
 */
export const IssueEventInfoSchema: GenMessage<IssueEventInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 6);

/**
 * @generated from message github.pull_requests.v1.PullRequestReviewInfo
 */
export type PullRequestReviewInfo = Message<"github.pull_requests.v1.PullRequestReviewInfo"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: int64 review_id = 2;
   */
  reviewId: bigint;

  /**
   * @generated from field: google.protobuf.Int32Value comment_count = 3;
   */
  commentCount?: number;

  /**
   * @generated from field: google.protobuf.BoolValue is_author = 4;
   */
  isAuthor?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue qualified_reviewer = 5;
   */
  qualifiedReviewer?: boolean;

  /**
   * @generated from field: string reviewer_type = 6;
   */
  reviewerType: string;

  /**
   * @generated from field: google.protobuf.StringValue dismissed_state = 7;
   */
  dismissedState?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestReviewInfo.
 * Use `create(PullRequestReviewInfoSchema)` to create a new message.
 */
export const PullRequestReviewInfoSchema: GenMessage<PullRequestReviewInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 7);

/**
 * @generated from message github.pull_requests.v1.PullRequestCommitInfo
 */
export type PullRequestCommitInfo = Message<"github.pull_requests.v1.PullRequestCommitInfo"> & {
  /**
   * @generated from field: string sha = 1;
   */
  sha: string;

  /**
   * @generated from field: google.protobuf.StringValue base_sha = 2;
   */
  baseSha?: string;

  /**
   * @generated from field: google.protobuf.StringValue short_message_text = 3;
   */
  shortMessageText?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestCommitInfo.
 * Use `create(PullRequestCommitInfoSchema)` to create a new message.
 */
export const PullRequestCommitInfoSchema: GenMessage<PullRequestCommitInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 8);

/**
 * @generated from message github.pull_requests.v1.PullRequestRevisionMarkerInfo
 */
export type PullRequestRevisionMarkerInfo = Message<"github.pull_requests.v1.PullRequestRevisionMarkerInfo"> & {
  /**
   * @generated from field: google.protobuf.StringValue last_seen_commit_oid = 1;
   */
  lastSeenCommitOid?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestRevisionMarkerInfo.
 * Use `create(PullRequestRevisionMarkerInfoSchema)` to create a new message.
 */
export const PullRequestRevisionMarkerInfoSchema: GenMessage<PullRequestRevisionMarkerInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 9);

/**
 * Discriminant for a TimelineItem. The arm of AdditionalInfo populated for an
 * item corresponds to its type.
 *
 * @generated from enum github.pull_requests.v1.TimelineItemType
 */
export enum TimelineItemType {
  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_COMMENT = 1;
   */
  ISSUE_COMMENT = 1,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_EVENT = 2;
   */
  ISSUE_EVENT = 2,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVIEW = 3;
   */
  PULL_REQUEST_REVIEW = 3,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_COMMIT = 4;
   */
  PULL_REQUEST_COMMIT = 4,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_CROSS_REFERENCE = 5;
   */
  CROSS_REFERENCE = 5,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVIEW_THREAD = 6;
   */
  PULL_REQUEST_REVIEW_THREAD = 6,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVISION_MARKER = 7;
   */
  PULL_REQUEST_REVISION_MARKER = 7,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_EDIT = 8;
   */
  ISSUE_EDIT = 8,
}

/**
 * Describes the enum github.pull_requests.v1.TimelineItemType.
 */
export const TimelineItemTypeSchema: GenEnum<TimelineItemType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_timeline, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(TimelineResponseSchema, "1cc23cdbc4c6")
registerSchemaHash(TimelineItemSchema, "70bfef10bb07")
registerSchemaHash(TimelineUserSchema, "e642c615009c")
registerSchemaHash(LabelSchema, "dc427465205b")
registerSchemaHash(AdditionalInfoSchema, "40d761984159")
registerSchemaHash(IssueCommentInfoSchema, "34a60a93fb78")
registerSchemaHash(IssueEventInfoSchema, "a0a6a84b26e2")
registerSchemaHash(PullRequestReviewInfoSchema, "82943eb9685a")
registerSchemaHash(PullRequestCommitInfoSchema, "b9896071c6ac")
registerSchemaHash(PullRequestRevisionMarkerInfoSchema, "0301979e3620")
